<template>
  <div class="row mx-1">
    <div class="col-md-6 card card-custom gutter-b mb-3">
      <!--begin::Header-->
      <div class="card-header border-0">
        <h3 class="card-title font-weight-bolder text-dark">اخبار ترمینال تبلیغات</h3>
      </div>
      <!--end::Header-->
      <div class="card-body pt-2">
        <!--begin::Item-->
        <div v-if="loading" class="row justify-content-center mt-10">
          <fingerprint-spinner
              :animation-duration="1500"
              :size="68"
              color="#ff1d5e"
          />
        </div>
        <div  class="justify-content-center text-center" v-if="news.length===0 && !loading">
          <div class="mt-15">
            <i class="fa la-frown fa-7x"></i>
            <h2 class="text-dark-50 mt-2">خبر تازه ای نیست.</h2>
          </div>
        </div>
        <div v-else class="d-flex flex-wrap align-items-center pb-10" v-for="item in news" :key="item.id">
          <!--begin::سیمبل-->
          <div class="symbol symbol-50 symbol-2by3 flex-shrink-0 mr-4">
            <div class="symbol-label" :style="{backgroundImage: `url('${item.picture}')`}"></div>
          </div>
          <!--end::سیمبل-->

          <!--begin::Title-->
          <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2 ">
            <router-link :to="{name:'news.index', params:{id:item.id}}"  class="text-dark font-weight-bold text-hover-primary mb-1 font-size-lg">
              <p class="text-truncate" style="width: 20rem">{{item.title}}</p>
            </router-link>
            <span class="text-muted font-weight-bold">{{item.updated_at_diff }}</span>
          </div>
          <!--end::Title-->

          <!--begin::Btn-->
          <button @click="$router.push({name:'news.index', params:{id:item.id}})"  class="text-dark-75 text-hover-primary font-weight-bold">
            مشاهده
          </button>
          <!--end::Btn-->
        </div>
        <!--end::Item-->
        <!--end::Item-->
      </div>
      <!--begin::Body-->
      <div class="card-body d-flex flex-column p-0">
        <!--begin::Stats-->
        <div class="mx-2">
        </div>
        <!--end::Stats-->
      </div>
      <!--end::Body-->
    </div>
    <div class="col-md-6">
      <fourtables></fourtables>
    </div>
  </div>
</template>

<script>
import Dropdown2 from "@/view/content/dropdown/Dropdown2.vue";
import {mapGetters} from "vuex";
import {FingerprintSpinner} from 'epic-spinners'
import fourtables from "@/view/pages/fourtables";


export default {
  name: "widget-10",
  components: {
    Dropdown2,
    fourtables,
    FingerprintSpinner
  },
  data() {
    return {

      chartOptions: {},
      model: null,
      loading:false,
      news: [],
      series: [
        {
          name: "Net Profit",
          data: [35, 65, 75, 55, 45, 60, 55]
        },
        {
          name: "Revenue",
          data: [40, 70, 80, 60, 50, 65, 60]
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  mounted() {
    this.getNews();
    this.chartOptions = {
      chart: {
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        },
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: ["30%"],
          endingShape: "rounded",
          barHeight: "20%"
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul"],
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      yaxis: {
        min: 0,
        max: 100,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          style: {
            colors: this.layoutConfig("colors.gray.gray-500"),
            fontSize: "12px",
            fontFamily: this.layoutConfig("font-family")
          }
        }
      },
      fill: {
        opacity: 1
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0
          }
        },
        hover: {
          filter: {
            type: "none",
            value: 0
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0
          }
        }
      },
      tooltip: {
        style: {
          fontSize: "12px",
          fontFamily: this.layoutConfig("font-family")
        },
        y: {
          formatter: function (val) {
            return "$" + val + " thousands";
          }
        }
      },
      colors: ["#fc8692", "#ffffff"],
      grid: {
        borderColor: this.layoutConfig("colors.gray.gray-200"),
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: false
          }
        }
      }
    };
  },

  methods: {
    getNews() {
      this.loading = true;
      this.requestApiGet('user/content?length=3&type=news')
          .then(({data})=>{
            this.news = data.data
            this.loading = false;
          });
    },
  },
};
</script>